import { createReducer, on } from '@ngrx/store';
import * as EntityActions from '@signature-it/ngx-entity/store/actions';
import { EntityStateModel } from '@signature-it/ngx-entity/store/models';

export const initialState = new EntityStateModel();

export const entityReducer = createReducer(
    initialState,
    on(EntityActions.getPreviews, (state) => ({ ...state, loadingPreviews: true })),
    on(EntityActions.getPreviewsSuccess, (state, templates) => ({ ...state, previews: templates, loadingPreviews: false})),
    on(EntityActions.getPreviewsError, (state, error) => ({ ...state, loadingPreviews: false})),
    on(EntityActions.getFavorites, (state) => (state)),
    on(EntityActions.getFavoritesSuccess, (state, {payload}) => ({ ...state, ...{
            favoritesList: payload,
            favoritesVars: payload.map(f => f.entity_var),
            loadingFavoritesList: false
        }})),
    on(EntityActions.getFavoritesFailure, (state) => ({ ...state, ...{
            loadingFavoritesList: false
        }})),
    on(EntityActions.addFavorite, (state, payload) => ({ ...state, ...{
            updatedFavoritesSuccess: false,
            processingAddToFavorites: true
        }})),
    on(EntityActions.addFavoriteSuccess, (state, payload) => ({ ...state, ...{
            favoritesVars: [...state.favoritesVars,  payload['entity_var']],
            updatedFavoritesSuccess: true,
            processingAddToFavorites: false
        }})),
    on(EntityActions.removeFavorite, (state) => ({ ...state, ...{
            removeFavoritesSuccess: false
        }})),
    on(EntityActions.removeFavoriteSuccess, (state, payload) => {
        const var1 = payload['entity_var'][0];
        return { ...state, ...{
                favoritesList: state.favoritesList.filter((fDTO) => fDTO.entity_var !== var1.toString()),
                favoritesVars: state.favoritesVars.filter((favorite) => favorite !== var1),
                removeFavoritesSuccess: true
            }}} ),
);
